module.exports = __webpack_public_path__ + "img/06-resilience-redundancy.2e27c574.jpg";